import React from "react";

const Modal = ({ post, ageGroup, onClose, onMarkRead }) => {
  const content = post.content[ageGroup] || post.content.adults; // Fallback to adults if age group missing
  const imageUrl = post.imageUrls?.[ageGroup] || post.imageUrls?.adults || "";
  const furtherReadingUrl = post.furtherReading?.[ageGroup] || post.furtherReading?.adults || "";
  const isRead = post.read;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-silver p-6 rounded-custom w-3/5 h-3/5 overflow-y-auto">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">{post.title}</h2>
        <div className="mb-4 text-gray-700 whitespace-pre-wrap">{content}</div>

        {imageUrl && (
          <div className="mb-4">
            <img
              src={imageUrl}
              alt={`${post.title} - ${ageGroup}`}
              className="w-full min-h-96 max-h-96 object-contain rounded-custom border border-gray-300"
              onError={(e) => {
                e.target.src = "https://placehold.co/400x200?text=Image+Not+Found";
              }}
            />
          </div>
        )}

        {furtherReadingUrl && (
          <div className="mb-4">
            <a
              href={furtherReadingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-blue-500 text-white px-4 py-2 rounded-custom hover:bg-blue-600 transition-colors"
            >
              Further Reading →
            </a>
          </div>
        )}

        <div className="flex space-x-2">
          <button
            onClick={onMarkRead}
            className="bg-kids-blue text-gray-800 px-4 py-2 rounded-custom hover:bg-blue-600"
          >
            {isRead ? "Mark as Unread" : "Mark as Read"}
          </button>
          <button
            onClick={onClose}
            className="bg-kids-blue text-gray-800 px-4 py-2 rounded-custom hover:bg-blue-600"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
